import React from 'react'

const StarsShape = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="137.2" height="138.6" viewBox="0 0 196 198" {...props}>
    <g clipPath="url(#clip0)" filter="url(#ds)">
      <path
        d="M64.5192 132.652L22.341 117.03C21.1779 116.599 20.1745 115.819 19.4657 114.797C18.7569 113.775 18.377 112.559 18.377 111.313C18.377 110.066 18.7569 108.85 19.4657 107.828C20.1745 106.806 21.1779 106.026 22.341 105.595L64.5192 89.9734L80.0614 47.5799C80.4907 46.411 81.2661 45.4024 82.2833 44.69C83.3004 43.9776 84.5103 43.5957 85.75 43.5957C86.9897 43.5957 88.1996 43.9776 89.2168 44.69C90.2339 45.4024 91.0093 46.411 91.4386 47.5799L106.981 89.9734L149.159 105.595C150.322 106.026 151.326 106.806 152.034 107.828C152.743 108.85 153.123 110.066 153.123 111.313C153.123 112.559 152.743 113.775 152.034 114.797C151.326 115.819 150.322 116.599 149.159 117.03L106.981 132.652L91.4386 175.045C91.0093 176.214 90.2339 177.223 89.2168 177.935C88.1996 178.647 86.9897 179.029 85.75 179.029C84.5103 179.029 83.3004 178.647 82.2833 177.935C81.2661 177.223 80.4907 176.214 80.0614 175.045L64.5192 132.652Z"
        fill="#78BE20"
      />
      <path
        d="M30.4084 60.8342L16.0416 55.5132C15.6455 55.3663 15.3037 55.1008 15.0623 54.7526C14.8208 54.4044 14.6914 53.9901 14.6914 53.5657C14.6914 53.1413 14.8208 52.7271 15.0623 52.3788C15.3037 52.0306 15.6455 51.7651 16.0416 51.6182L30.4084 46.2972L35.7024 31.8571C35.8486 31.4589 36.1127 31.1154 36.4592 30.8727C36.8056 30.6301 37.2178 30.5 37.64 30.5C38.0623 30.5 38.4744 30.6301 38.8209 30.8727C39.1673 31.1154 39.4315 31.4589 39.5777 31.8571L44.8717 46.2972L59.2384 51.6182C59.6346 51.7651 59.9764 52.0306 60.2178 52.3788C60.4592 52.7271 60.5886 53.1413 60.5886 53.5657C60.5886 53.9901 60.4592 54.4044 60.2178 54.7526C59.9764 55.1008 59.6346 55.3663 59.2384 55.5132L44.8717 60.8342L39.5777 75.2743C39.4315 75.6725 39.1673 76.016 38.8209 76.2587C38.4744 76.5013 38.0623 76.6314 37.64 76.6314C37.2178 76.6314 36.8056 76.5013 36.4592 76.2587C36.1127 76.016 35.8486 75.6725 35.7024 75.2743L30.4084 60.8342Z"
        fill="#78BE20"
      />
    </g>

    <defs>
      <clipPath id="clip0">
        <rect
          width="196"
          height="197"
          fill="#fff"
          transform="translate(0 .5)"
        />
      </clipPath>

      <filter id="ds" x="-10%" y="-10%" width="120%" height="120%">
        <feDropShadow
          dx="1.5"
          dy="1.5"
          stdDeviation="0.8"
          floodColor="#CEDC00"
          floodOpacity="1"
        />
      </filter>
    </defs>
  </svg>
)

export default StarsShape
